/**
 * Constructs the Cognito hosted-UI domain for a tenant's user pool.
 *
 * This duplicates `shared/utils/src/cognito-domain.ts` because the UI bundle
 * cannot depend on `@policy-tracker/utils` (it pulls in AWS SDK + DynamoDB
 * client packages that must never reach the browser). Drift is caught by
 * `src/__tests__/cognito-domain.test.ts`, which loads BOTH implementations
 * (the UI's and the shared one via a path-relative deep import) and asserts
 * they produce identical strings for the same inputs.
 *
 * The CDK construct at `services/tenant/infrastructure/tenant-resources-stack.ts`
 * sets the user-pool domain prefix to `<tenantIdLowered>-<awsAccount>`. The
 * full hosted-UI URL Cognito serves is then
 * `<prefix>.auth.<region>.amazoncognito.com`.
 *
 * @param input.tenantId - the tenant id from `TenantConfiguration.tenantId`; case-insensitive
 * @param input.awsAccount - the AWS account from `TenantConfiguration.awsAccount`
 * @param input.region - the AWS region from `TenantConfiguration.region`
 * @returns the full hosted-UI domain (no scheme, no path)
 */
export function getCognitoHostedDomain(input: { tenantId: string; awsAccount: string; region: string }): string {
    return `${input.tenantId.toLowerCase()}-${input.awsAccount}.auth.${input.region}.amazoncognito.com`;
}
